import Hero from "./Hero";

const Styleguide = () => {
  return (
    <>
      <Hero />
    </>
  );
};

export default Styleguide;
